import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Stack } from "components/layout/reusableLayouts";

/** The shipping-service window hint, shared by CardFormDrawer and CardShippingDetails. */
export const useShippingServiceTooltip = () => {
  const { t } = useTranslation();

  return (
    <Stack gap="var(--space-2)">
      <Typography
        variant="body2"
        component="div"
        sx={{ color: "var(--color-text-inverse)" }}
      >
        <strong>{t("ShippingServiceStandardLabel")}:</strong>{" "}
        {t("ShippingServiceStandardWindow")}
      </Typography>
      <Typography
        variant="body2"
        component="div"
        sx={{ color: "var(--color-text-inverse)" }}
      >
        <strong>{t("ShippingServiceExpressLabel")}:</strong>{" "}
        {t("ShippingServiceExpressWindow")}
      </Typography>
      <Typography
        variant="body2"
        component="div"
        sx={{ color: "var(--color-text-inverse)" }}
      >
        {t("ShippingServiceIncludesPrintTime")}
      </Typography>
    </Stack>
  );
};
